
function InfoModal({ isOpen, onClose, title, message }) {
  // If the modal isn't set to be open, render nothing
  if (!isOpen) return null;

  return (
    // Backdrop overlay
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose} // Close modal if backdrop is clicked
    >
      {/* Modal Content Box */}
      <div
        className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-sm w-full text-white"
        onClick={(e) => e.stopPropagation()} // Prevent click inside modal from closing it via backdrop click
      >
        {/* Optional Title */}
        {title && <h3 className="text-lg font-semibold mb-2 text-center">{title}</h3>}

        {/* Message */}
        <p className="mb-5 text-center">{message}</p>

        {/* Button Container - Centered */}
        <div className="flex justify-center">
          <button
            onClick={onClose} // Close modal on button click
            className="px-6 py-2 bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

export default InfoModal;